import { ICreateOrderRequest, IOrder, IOrderResult } from "../types/IOrder";
import { IVerifyPaymentResult } from "../types/IPayment";
import { HttpClient } from "./http/httpclient.service";
import { ApiRoutes } from "./http/routes";

export const OrderService = {

    createOrder: async (req: ICreateOrderRequest): Promise<IOrderResult> => {
        try {
            const response = await HttpClient.post<IOrderResult, ICreateOrderRequest>({
                route: ApiRoutes.CreateOrder,
                body: req
            });
            return response.data as IOrderResult;
        } catch (error) {
            console.error("Error adding product to cart:", error);
            throw error;
        }
    },
    getAllOrders: async (): Promise<IOrder[]> => {
        try {
            const response = await HttpClient.get<IOrder>({
                route: ApiRoutes.GetOrders,
            });
            return (response.data || []) as IOrder[];
        } catch (error) {
            console.error("Error adding product to cart:", error);
            throw error;
        }
    },

    getOrderDetails: async (orderId:string): Promise<IOrder> => {
        try {
            const response = await HttpClient.get<IOrder>({
                route: ApiRoutes.GetOrder,
                uriParams: ({ orderId})
            });
            return (response.data) as IOrder;
        } catch (error) {
            console.error("Error getOrderDetails:", error);
            throw error;
        }
    },
    verifyPayment: async (req: any): Promise<IOrder> => {
        try {
            const response = await HttpClient.post<IOrder, any>({
                route: ApiRoutes.VerifyPayment,
                body: req
            });
            return response.data as IOrder;
        } catch (error) {
            console.error("Error adding product to cart:", error);
            throw error;
        }
    },
    validateCoupon: async(couponCode:string,customerId:string): Promise<number> => {
        try{
            const response = await HttpClient.post<number,any>({
                route: ApiRoutes.ValidateCoupon,
                uriParams: { customerId: customerId,couponCode: couponCode }
            });
            return response.data?response.data:0;
        }
        catch(error)
        {
            console.error("Error validating coupon: ",error);
            throw error;
        }
    }

}